import React, {useEffect, useState} from "react";
import AutoFormCard from "../../../components/common/AutoFormCard";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ApiService} from "../../../services/ApiService";
import {message} from "antd";
import {FormUtils} from "../../../utils/FormUtils";

const FORM = [
    {
        name: "所属场所",
        key: "venueId",
        type: "select",
        required: true,
    },
    {
        name: "相机名称",
        key: "name",
        type: "input",
        required: true,
    },
    {
        name: "频道名称",
        key: "channelName",
        type: "input",
    },
    {
        name: "设备ID（卡口ID）",
        key: "devicePlatformId",
        type: "input",
    },
    {
        name: "HLS地址",
        key: "hlsUrl",
        type: "input"
    },
    {
        name: "RTSP地址",
        key: "rtmpUrl",
        type: "input",
    }
]

const ReligionVenueEditPage = () => {
    const [searchParams] = useSearchParams()
    const navigator = useNavigate()

    const guid = searchParams.get("guid")

    const [initFormData, setInitFormData] = useState({})
    const [venues, setVenues] = useState([])
    const [configs, setConfigs] = useState([])

    let changedForms = {}
    let changedFiles = {}

    useEffect(() => {
        if (guid) {
            ApiService.admin.camera.get(guid)
                .onSuccess(data => {
                    setInitFormData(data)
                })
        }

        ApiService.admin.camera.config.list(0, 1000)
            .onSuccess(data => {
                setConfigs(data.content.map(item => {
                    return {name: item.ipAddress, value: item.guid}
                }))
            })

        ApiService.admin.religion.venue.list(0, 1000)
            .onSuccess(data => {
                setVenues(data.content.map(item => {
                    return {name: item.name, value: item.guid}
                }))
            })
    }, [guid]);

    const handleFormChange = (change) => {
        changedForms = {
            ...changedForms,
            ...change
        }
    }

    const handleFileChange = (change) => {
        changedFiles = {
            ...changedFiles,
            ...change
        }
    }

    const createOrUpdate = (form) => {
        if (guid) {
            return ApiService.admin.camera.update(form)
        } else {
            return ApiService.admin.camera.create(form)
        }
    }

    const handleFormSubmit = (event) => {
        try {
            const form = FormUtils.setupSubmitForm(changedForms, changedFiles, true, false, {guid: guid})
            createOrUpdate(form)
                .onSuccess(() => {
                    message.success("数据已保存")
                    navigator(-1)
                })
        } catch (e) {
            message.error(e.message)
            return false
        }
    }

    return (
        <>
            <AutoFormCard
                title={"编辑摄像机"}
                formStruct={FORM}
                initValues={initFormData}
                selectOptions={{
                    venueId: venues,
                    configId: configs
                }}
                loading={false}
                onClickCancel={e => {
                    navigator(-1)
                }}
                onClickSubmit={handleFormSubmit}
                onFormChange={handleFormChange}
                onFileChange={handleFileChange}
            />
        </>
    )
}

export default ReligionVenueEditPage